import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import { isNil, trim, get, flattenDeep, isPlainObject } from "lodash-es";
import { parse } from "./pegParser";
export var tokenize = function tokenize(expression) {
  var tokens = isNil(expression) || trim("" + expression) === "" ? [] : parse("" + expression);
  return flattenDeep(tokens);
}; // ToDo: test extensively (helpful for testing: https://pegjs.org/online & grammar.txt)

export var rename = function rename() {
  var expression = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var type = arguments[1];
  var oldName = arguments[2];
  var newName = arguments[3];
  var tableName = arguments[4];
  var tokens = tokenize(expression).map(function (token) {
    if (!isPlainObject(token) || !token.type) {
      return token;
    } // skip if types not consistent, apart from when type === "column"
    // because type "column" is nested in table


    if (type !== "column" && token.type !== type) {
      return token.text || token;
    }

    switch (type) {
      case "formula":
        {
          if (token.name === oldName) {
            return newName;
          }

          return token.name;
        }

      case "table":
        {
          if (token.name === oldName) {
            return "" + newName + token.text.substring(oldName.length);
          }

          return token.text;
        }

      case "column":
        {
          if (token.name !== tableName) {
            break;
          }

          var intraTableReferences = token.intraTableReference.map(function (tableToken) {
            if (get(tableToken, "type") !== "column") {
              return tableToken;
            }

            if (tableToken.name !== oldName) {
              return tableToken.name || tableToken;
            }

            return newName;
          }).join("");
          return "" + tableName + intraTableReferences;
        }
    }

    return token.text || token;
  });
  return tokens.join("");
};